import { getGenericDocumentsPortalApp, } from '@zurich/api/document';
import { useFetchApi, useTranslation } from '@zurich/common/hooks';
export const useGetGenericDocumentsPortal = () => {
    const { t } = useTranslation();
    const { fetchApi } = useFetchApi();
    const handleFetch = async (offerId, documentIds) => {
        const ret = await fetchApi(getGenericDocumentsPortalApp, {
            vars: { offerId, documentIds: documentIds.join(',') },
        }, {
            errorText: t('document.errors.loadDocument'),
        });
        if (!ret) {
            throw new Error(t('document.errors.loadDocument'));
        }
        return ret;
    };
    return handleFetch;
};
